import React, { useRef, useState, useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';

import { getColumnsPayments } from '../table/getColumns';
import { Table } from '../../../../../components/table';
import MathPlexContractModal from '../../../../../components/modal/contracts/MathPlexContractModal';
import ContractModal from '../../contracts/ContractModal';
import MathPlexPaymentsModal from '../../../../../components/modal/payments/MathPlexPaymentsModal';
import ReadingPlexPaymentsModal from '../../../../../components/modal/payments/ReadingPlexPaymentsModal';

import {

} from '../../../../../actions';

// Portal detection
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isReadingPlex = hostname.includes('readingplex');

const defaultSorted = { dataField: 'date', order: 'asc' };

function PaymentsTable(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentModalMode, setPaymentModalMode] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [showContractModal, setShowContractModal] = useState(false);
    const [contractModalMode, setContractModalMode] = useState(null);
    const [selectedContract, setSelectedContract] = useState(null);

    const { payments, refreshData, students, contracts,
        createPayment, updatePayment, deletePayment,
        createContract, updateContract, deleteContract,
        fetchContractsIds, fetchPaymentsIds, fetchContractsStudentNames } = props;

    const handleShowPaymentModal = useCallback((mode, payment) => {
        if(mounted.current){
            setPaymentModalMode(mode);
            setSelectedPayment(payment);
            setShowPaymentModal(true);
        }
    }, [mounted]);
    const handleClosePaymentModal = useCallback((shouldRefresh = false) => {
        if(mounted.current){
            setShowPaymentModal(false);
            setPaymentModalMode(null);
            setSelectedPayment(null);
            if(shouldRefresh) refreshData();
        }
    }, [mounted, refreshData]);
    const handleShowContractModal = useCallback((mode, contract) => {
        if(mounted.current){
            setContractModalMode(mode);
            setSelectedContract(contract);
            setShowContractModal(true);
        }
    }, [mounted]);
    const handleCloseContractModal = useCallback((shouldRefresh = false) => {
        if(mounted.current){
            setShowContractModal(false);
            setContractModalMode(null);
            setSelectedContract(null);
            if(shouldRefresh) refreshData();
        }
    }, [mounted, refreshData]);

    const columns = useMemo(() => getColumnsPayments(handleShowPaymentModal, handleShowContractModal),
        [handleShowPaymentModal, handleShowContractModal]);

    return (
        <div>
            {showPaymentModal && 
                (isReadingPlex ? (
                    <ReadingPlexPaymentsModal
                        show={showPaymentModal}
                        mode={paymentModalMode}
                        payment={selectedPayment}
                        students={students || []}
                        onClose={handleClosePaymentModal}
                        createPayment={createPayment}
                        updatePayment={updatePayment}
                        deletePayment={deletePayment}
                    />
                ) : (
                    <MathPlexPaymentsModal
                        show={showPaymentModal}
                        mode={paymentModalMode}
                        payment={selectedPayment}
                        students={students || []}
                        onClose={handleClosePaymentModal}
                        createPayment={createPayment}
                        updatePayment={updatePayment}
                        deletePayment={deletePayment}
                    />
                ))
            }
            {showContractModal &&
                (isReadingPlex ? (
                    <ContractModal
                        show={showContractModal}
                        mode={contractModalMode}
                        contract={selectedContract}
                        students={students || []}
                        onClose={handleCloseContractModal}
                        createContract={createContract}
                        updateContract={updateContract}
                        deleteContract={deleteContract}
                    />
                ) : (
                    <MathPlexContractModal
                        show={showContractModal}
                        mode={contractModalMode}
                        contract={selectedContract}
                        students={students || []}
                        onClose={handleCloseContractModal}
                        createContract={createContract}
                        updateContract={updateContract}
                        deleteContract={deleteContract}
                    />
                ))
            }
            <Table
                tableName="payments"
                data={payments}
                columns={columns}
                defaultSorted={defaultSorted}
                emptyMessage="No payments were found"
            />
        </div>
    );
}

export default connect(null, {

})(PaymentsTable);